import React, { Component } from "react";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import withStyles from "@material-ui/core/styles/withStyles";
import { FastField, Field } from "formik";
import { getFieldStatus } from "./common";

class SelectFieldInner extends Component {
  getOptions = () => {
    let opts = [];

    if (this.props.options) {
      if (typeof this.props.options !== "function") {
        opts = this.props.options;
      } else {
        const getOpts = this.props.options(this.props.form.values);
        if (getOpts && getOpts.then) {
          getOpts.then(options => this.setState({ options }));
        } else {
          opts = getOpts;
        }
      }
    }

    if (this.state) this.setState({ options: opts });
    else return opts;
  };

  state = {
    options: this.getOptions()
  };

  componentDidMount = this.getOptions;

  componentDidUpdate = prevProps => {
    if (prevProps.form.values !== this.props.form.values) this.getOptions();
  };

  onChange = e => {
    this.props.field.onChange(e);
    this.props.onChange &&
      this.props.onChange(e, this.props.form, this.props.field);
  };

  render = () => {
    const {
      name,
      options,
      label: labelProp = name,
      field,
      form,
      disabled: disabledProp,
      value: valueProp,
      ...props
    } = this.props;

    const { error, hasError, disabled, label, value } = getFieldStatus(
      form,
      field,
      valueProp,
      labelProp,
      disabledProp
    );

    const fieldVal = value === undefined || value === null ? "" : value;
    const isNative = props.SelectProps && props.SelectProps.native;

    return (
      <TextField
        select
        label={label}
        name={name}
        id={name}
        inputProps={{ onBlur: field.onBlur }}
        value={fieldVal}
        error={hasError}
        helperText={hasError && error}
        disabled={disabled}
        {...props}
        onChange={this.onChange}
      >
        {this.state.options.map(o =>
          isNative ? (
            <option key={o.value} value={o.value}>
              {o.label || o.value}
            </option>
          ) : (
            <MenuItem key={o.value} value={o.value}>
              {o.label || o.value}
            </MenuItem>
          )
        )}
      </TextField>
    );
  };
}

export default withStyles({}, { name: "LcSelectField" })(
  ({
    classes,
    name,
    fast = true,
    FieldComponent = fast ? FastField : Field,
    ...props
  }) => (
    <FieldComponent name={name}>
      {({ field, form }) => (
        <SelectFieldInner field={field} form={form} name={name} {...props} />
      )}
    </FieldComponent>
  )
);
